/// <reference path="../../../models/chat.ts"/>
/// <reference path="../../../utils/searchFilter.ts"/>

import { Meeting } from '../../../models/chat';
import { ChatService } from '../../../ng-services/chat.service';
import { searchFilter } from '../../../utils/searchFilter';

(function () {
    class MeetingListComponent {
        static $inject = ['$timeout', 'ChatService', '$filter'];
        public pinnedMeetingId?: number;

        public isLoading: boolean = true;
        public filter: string = '';
        public filter$: Rx.BehaviorSubject<string> = new Rx.BehaviorSubject<string>(this.filter);
        public meetings!: Meeting[];
        public activeMeeting?: Meeting | null;
        private subscriptions: Rx.Disposable[];

        constructor(
            private $timeout: angular.ITimeoutService,
            private chatService: ChatService,
            private $filterService: angular.IFilterService
        ) {
            this.subscriptions = [
                this.chatService
                    .getMeetings$()
                    .map((meetings: Meeting[]) => {
                        return this.$filterService('orderBy')(meetings, [
                            (meeting: Meeting) => (meeting.id === 0 ? -1 : 0), // Public meeting should be first
                            this.orderByPinnedFirst,
                            '!lastMessageDate',
                            '-lastMessageDate',
                        ]);
                    })
                    // filter list of meetings using filter
                    .combineLatest(this.filter$)
                    .map(([data, filter]) => data.filter((conversation) => searchFilter(filter, conversation.name)))
                    .subscribe((data) => {
                        $timeout(() => {
                            this.isLoading = false;
                            this.meetings = data;
                        });
                    }),
                this.chatService.getActiveMeeting$().subscribe((active) => {
                    this.activeMeeting = active;
                }),
            ];
        }

        get noResults() {
            return this.filter && !this.isLoading && this.meetings.length === 0;
        }

        get isEmpty() {
            return !this.filter && !this.isLoading && this.meetings.length === 0;
        }

        public onActivate = (conversation: Meeting) => {
            this.chatService.setActiveMeeting(conversation);
            this.onFilterChange('');
        };

        public onFilterChange = (filter: string) => {
            this.filter = filter;
            this.filter$.onNext(this.filter);
        };

        $onDestroy() {
            this.subscriptions.forEach((sub) => sub.dispose());
        }

        orderByPinnedFirst = (meeting: Meeting) => (meeting.id === this.pinnedMeetingId ? -1 : 0);
    }

    angular.module('tradersyard').component('tyMeetingList', {
        // language=HTML
        template: `
            <div class="meeting_list">
                <div class="meeting_list__filter">
                    <ty-filter
                        value="$ctrl.filter"
                        on-change="$ctrl.onFilterChange"
                        placeholder="Filter conversations"
                    />
                </div>
                <div class="meeting_list__items" ng-if="!$ctrl.isLoading">
                    <ty-meeting-list-item
                        ng-repeat="meeting in $ctrl.meetings track by meeting.id"
                        is-pinned="meeting.id === $ctrl.pinnedMeetingId"
                        conversation="meeting"
                        filter="$ctrl.filter"
                        on-activate="$ctrl.onActivate"
                        is-active="$ctrl.activeMeeting && $ctrl.activeMeeting.id === meeting.id"
                    />
                </div>
                <div class="meeting_list__message" ng-if="$ctrl.isLoading">
                    <ty-loading-spinner/>
                </div>
                <div class="meeting_list__message" ng-if="$ctrl.noResults">
                    No results found
                </div>
                <div class="meeting_list__message" ng-if="$ctrl.isEmpty">
                    No conversations
                </div>
            </div>
        `,
        controller: MeetingListComponent,
        bindings: {
            pinnedMeetingId: '<',
        },
    });
})();
